import { AnimationPlayer } from "@angular/animations";
import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/core/helpers/auth.service";
import { CoreService } from "src/app/core/helpers/core.service";
import { DataServiceService } from "src/app/core/helpers/data-service.service";
import { GaService } from "src/app/core/helpers/ga.service";

@Component({
  selector: "loyaltic-upload-receipt",
  templateUrl: "./upload-receipt.component.html",
  styleUrls: ["./upload-receipt.component.scss"],
})
export class UploadReceiptComponent implements OnInit {
  receipt: any;
  Quantity = 1;
  receiptSrc: any;
  removeLocalProductList = true;
  ReceiptName = "";
  culture = "";
  product1 = null;
  product2 = null;
  product3 = null;
  product4 = null;
  product5 = null;
  prodQuantityOne = 0;
  prodQuantityTwo = 0;
  prodQuantityThree = 0;
  prodQuantityFour = 0;
  prodQuantityFive = 0;
  List: any[] = [];
  @ViewChild("tryagainReceiptUpload", { static: false })
  tryagainReceiptUploadRef: any;
  @ViewChild("uploadAnimation", { static: false }) uploadAnimationRef: any;
  @ViewChild("thankyouApprovedPopup", { static: false }) thankyouApprovedPopupRef: any;
  @ViewChild("uploadHelp", { static: false }) uploadHelpPopupRef: any;
  public modalRef!: BsModalRef;
  confirmationReasons :any[] = [];

  showConfirmReceiptUploadPopUp = false;
  @Output() receiptUploadSuccess = new EventEmitter<any>();

  popupConfig = {
    ignoreBackdropClick: true,
    class:
      "lyltc animation modal-md modal-dialog-centered modal-dialog-animation",
  };

  confirmPopupConfig = {
    ignoreBackdropClick: true,
    class: "lyltc modal-md modal-dialog-centered",
  };
  showSurvey = true;
  IsKotiPizzaStore = false;
  isFinnish = false;
  productList: any;
  productQuantity = new Array(10);
  categories: any[] = [];
  rejectedReasons: any[] = [];
  selectedProducts = [
    {category: '', productId: '', productName: null, quantity: 0, filteredProducts: [], isOther: false, amount: 0}
  ]

  constructor(
    private authService: AuthService,
    private coreService: CoreService,
    private toast: ToastrService,
    private translate: TranslateService,
    private router: Router,
    private dataService: DataServiceService,
    private modalService: BsModalService,
    private gaService: GaService
  ) {
    this.culture = translate.getDefaultLang();
    if (this.culture == 'fi-FI') {
      this.isFinnish = true;
    }
  }

  ngOnInit() {
    if (localStorage.getItem("surveyTaken") == "true") {
      this.showSurvey = false;
    }
    this.loadProducts(); 
  }

  loadProducts() {
    this.coreService.getProducts().then((apiResponse: any) => {
      const apiResult = apiResponse && apiResponse.result ? apiResponse.result : {};
      this.categories = apiResult.categories || [];
      const categoryProducts = this.flattenProductCategories(apiResult.categories || []);

      this.productList = categoryProducts.length
        ? categoryProducts
        : this.normalizeProducts(apiResult.purchasedProducts || []);
      this.restoreSelectedProducts();
    });
  }

  flattenProductCategories(productCategoryData: any[]) {
    if (!Array.isArray(productCategoryData)) {
      return [];
    }

    return productCategoryData.reduce((products: any[], item: any) => {
      if (item && Array.isArray(item.products)) {
        item.products.forEach((product: any) => {
          products.push({
            productId: product.productId || null,
            name: product.name,
            category: item.category || product.category || "Other",
            pointsPerProduct: product.pointsPerProduct || 0
          });
        });
        return products;
      }

      if (item && item.name) {
        products.push({
          productId: item.productId || null,
          name: item.name,
          category: item.category || "Other",
          pointsPerProduct: item.pointsPerProduct || 0
        });
      }

      return products;
    }, []);
  }

  normalizeProducts(apiProducts: any[]) {
    return (apiProducts || []).map((product: any) => ({
      productId: product.productId || product.ProductId || product.id || null,
      name: product.name || product.ProductName || product.productName,
      category: product.category || product.Category || "Other",
      pointsPerProduct: product.pointsPerProduct || product.PointsPerProduct || product.points || 0
    })).filter((product: any) => product.name);
  }

  restoreSelectedProducts() {
    if (localStorage.getItem('productList')) {
      let storedProducts = JSON.parse(localStorage.getItem('productList'));
      if (storedProducts.length > 0) {
        this.selectedProducts  = [];
        storedProducts.map((product:any) => {
          const found = this.findProductByName(product.ProductName);
          let data = {
            category: product.Category,
            productId: (found && found.productId) ? found.productId : product.ProductId,
            productName : product.ProductName,
            quantity: product.Quantity,
            filteredProducts: [],
            isOther: product.IsOther || false,
            amount: product.Amount || 0
          }
          this.selectedProducts.push(data);
        })
      }
    }
  }

  // onReceiptSelect(event) {
  //   this.receipt = event.target.files[0];
  // }
  
  onReceiptSelect(event:any) {
    this.receipt = event.target.files[0];
    this.ReceiptName = this.receipt.name;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (e: any) => {
        const img = document.createElement("img");
        img.src = e.target.result;
        this.receiptSrc = e.target.result;
      };
    }
  }
  openProductHelp() {
    this.modalRef = this.modalService.show(
      this.uploadHelpPopupRef,
      this.popupConfig = {
        ignoreBackdropClick: false,
        class:
          "lyltc animation modal-md modal-dialog-centered modal-dialog-animation",
      }
    );
  }
  showAnimationPopup() {
    this.modalRef = this.modalService.show(
      this.uploadAnimationRef,
      this.popupConfig
    );
  }

  onProductSelect(_event: any, index: number) {
    const productName = this.selectedProducts[index].productName;
    const product = (this.selectedProducts[index].filteredProducts || []).find((p: any) => p.name === productName)
                    || this.findProductByName(productName);
    if (product && product.productId === '__OTHER__') {
      this.selectedProducts[index].isOther = true;
      this.selectedProducts[index].productId = '';
      this.selectedProducts[index].amount = 0;
    } else {
      this.selectedProducts[index].isOther = false;
      this.selectedProducts[index].productId = product ? product.productId : '';
      this.selectedProducts[index].amount = 0;
    }
  }

  onCategoryChange(index: number) {
    this.selectedProducts[index].productName = null;
    this.selectedProducts[index].productId = '';
    this.selectedProducts[index].filteredProducts = [];
    this.selectedProducts[index].isOther = false;
    this.selectedProducts[index].amount = 0;
  }

  onSearch(term: string, index: number) {
    const category = this.selectedProducts[index].category;
    if (!term || !category) {
      this.selectedProducts[index].filteredProducts = [];
      return;
    }

    const categoryProducts = this.getProductsByCategory(category);
    this.selectedProducts[index].filteredProducts = categoryProducts.filter(x =>
      x.name.toLowerCase().includes(term.toLowerCase())
    );
  }

  getProductsByCategory(categoryName: string) {
    const category = this.categories.find(c => c.category === categoryName);
    const products: any[] = category ? [...category.products] : [];
    products.push({ productId: '__OTHER__', name: 'Muu tuote', category: categoryName, pointsPerProduct: 0 });
    return products;
  }

  findProductByName(name: string) {
    return this.productList && this.productList.find((p: any) => p.name === name);
  }

  addMoreProduct() {
    let prod = {category: '', productId: '', productName: null, quantity: 0, filteredProducts: [], isOther: false, amount: 0};
    this.selectedProducts.push(prod);
  }

  removeProductAt(index: number) {
    this.selectedProducts.splice(index, 1);
  }

  parseAmount(value: any): number {
    if (!value) return 0;
    return parseFloat(value.toString().replace(',', '.')) || 0;
  }

  onReceiptUpload(form:any) {
    const userId = this.authService.getUserId();
    const IsReUpload = localStorage.getItem('IsReUpload');
    this.List = [];

    this.selectedProducts.forEach((prod:any) => {
      let product = this.findProductByName(prod.productName) || {};
      let data = {
        'ProductId': prod.isOther ? '' : ((product as any).productId || prod.productId),
        'ProductName': prod.productName,
        'Category': (product as any).category || '',
        'Quantity': prod.quantity,
        'PointsPerProduct': (product as any).pointsPerProduct || 0,
        'IsOther': prod.isOther || false,
        'Amount': prod.isOther ? this.parseAmount(prod.amount) : 0
      }
      this.List.push(data);
    })

    this.showAnimationPopup();

    
    localStorage.setItem('productList', JSON.stringify(this.List));
    const formData = new FormData();
    formData.append("UserId", userId);
    formData.append("Quantity", this.Quantity.toString());
    formData.append("Culture", this.translate.getDefaultLang());
    formData.append("File", this.receipt);
    formData.append("IsReUpload", IsReUpload === "1" ? "true" : "false");
    formData.append("Purchases", JSON.stringify(this.List));

    this.coreService
      .upLoadReceipt(formData)
      .then((res: any) => {
        localStorage.removeItem('modalDisplayed')
        this.modalRef.hide();
        form.submitted = false;
        this.resetForm();
        //this.toast.success(this.translate.instant('' + res.messageKey), this.translate.instant('success'));
        this.receiptUploadSuccess.emit(res.result);
        this.rejectedReasons = res.result.rejectedReasons;
        this.confirmationReasons = res.result.rejectedReasons;

        if (res.result.isnewRegistration) {
          this.gaService.emitEvent("Registration", "success");
        }
        this.coreService.rejectedReasons = res.feedbackMessages;



        if (!res.result.isapproved && res.result.tryagain) {
          this.removeLocalProductList  = false;
          this.modalRef = this.modalService.show(
            this.tryagainReceiptUploadRef,
            this.confirmPopupConfig
          );
          return;
        }

        if (
          !res.result.isapproved &&
          res.result.recptPartitionKey &&
          res.result.recptRowKey
        ) {
          this.removeLocalProductList = false;
          //this.authService.setToken(res.result.token, res.result.id);
          this.dataService.setReceiptNotApprovedData(res.result);
          this.showConfirmReceiptUploadPopUp = true;
          return;
        }
        if (res.result.isapproved) {
          localStorage.removeItem('productList');
          localStorage.setItem("IsReUpload", "0");
          this.modalRef = this.modalService.show(this.thankyouApprovedPopupRef, this.confirmPopupConfig);
        }
      })
      .catch((errorResponse: any) => {
        // this.resetForm();
        const errorMessage = this.translate.instant(
          errorResponse.error.messageKey
        );
        this.toast.error(errorMessage, "");
        return;
      });
  }

  tryAgain() {
    this.resetForm();
    this.modalRef.hide();
    this.coreService.pointsEmitter.emit(true);
    this.router.navigate(["/upload"]);
  }

  resetForm() {
    this.ReceiptName = "";
    this.Quantity = 1;
    this.receipt = undefined;
    this.selectedProducts = [{category: '', productId:'', productName: null, quantity: 0, filteredProducts: [], isOther: false, amount: 0 }];
    this.List = [];
  }

  surveyTaken() {
    localStorage.setItem("surveyTaken", "true");
    this.showSurvey = false;
  }

  ngOnDestroy() {
    if (this.removeLocalProductList) {
      localStorage.removeItem('productList');
    }
  }
}
